import Grid from '@mui/material/Grid2';
import React from 'react';

import { ClickableImageContainer } from '../ClickableImageContainer/ClickableImageContainer';
import { ImageObject } from '../ImageSection.types';
import { AdditionalImageLabel } from './AdditionalImageLabel/AdditionalImageLabel';

interface PreviewImageProps {
  imageObject: ImageObject;
  additionalImageCount?: number;
  onClick: React.MouseEventHandler;
}

export const PreviewImage: React.FunctionComponent<PreviewImageProps> = ({
  imageObject,
  additionalImageCount = 0,
  onClick,
}: PreviewImageProps) => {
  return (
    <Grid size={6}>
      <ClickableImageContainer
        imageObject={imageObject}
        onClick={onClick}
        additionalContent={
          additionalImageCount > 0 && <AdditionalImageLabel additionalImageCount={additionalImageCount} />
        }
      />
    </Grid>
  );
};

PreviewImage.displayName = 'PreviewImage';
